import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Organizi8EnvProvider } from './organizi8.env.provider';
import { of } from 'rxjs';
import {
  TREQUEST_GetMaterialRequestsListing,
  TREQUEST_FabricGRNLotDetails,
  TREQUEST_FabricGRNLotListing,
  TRESPONSE_GetMaterialRequestDetails,
  TRESPONSE_GetMaterialRequestsListing,
  TRESPONSE_FabricGRNLotDetails,
  TRESPONSE_TrimsGRNLotListing,
  TREQUEST_AvailableLocationsListing,
  TRESPONSE_AvailableLocationsListing,
  TREQUEST_ItemsStoredInLocationDetails,
  TRESPONSE_ItemsStoredInLocationDetails,
  TREQUEST_GetNewLocationDetails,
  TRESPONSE_GetNewLocationDetails,
  TREQUEST_ConfirmItemsTransfer,
  TRESPONSE_ConfirmItemsTransfer,
  TRESPONSE_FabricGRNLotListing,
  TREQUEST_TrimsGRNLotListing,
  TREQUEST_GenerateGRNTag,
  TRESPONSE_GenerateGRNTag,
  TREQUEST_FabricStorageGRNDetails,
  TRESPONSE_FabricStorageGRNDetails,
  TREQUEST_TrimsStorageGRNDetails,
  TRESPONSE_TrimsStorageGRNDetails,
  TREQUEST_FabricStorageRollsDetails,
  TREQUEST_TrimsStorageItemDetails,
  TRESPONSE_TrimsStorageItemDetails,
  TREQUEST_AddFabricRollsToStorage,
  TRESPONSE_AddFabricRollsToStorage,
  TREQUEST_AddTrimItemsToStorage,
  TRESPONSE_AddTrimItemsToStorage,
  TREQUEST_TrimsGRNLotDetails,
  TRESPONSE_TrimsGRNLotDetails,
  TRESPONSE_FabricStorageRollsDetails,
  TREQUEST_GetMaterialRequestDetails,
  TREQUEST_GetLocationDetails,
  TRESPONSE_GetLocationDetails,
  TREQUEST_GetRollDetailsFromRollId,
  TREQUEST_MaterialRequestCounts,
  TRESPONSE_MaterialRequestCounts,
  TREQUEST_IssueSelectedMaterial,
  TRESPONSE_IssueSelectedMaterial,
  TREQUEST_FetchTrimItemDetailsWithSizes,
  TRESPONSE_FetchTrimItemDetailsWithSizes,
  TRESPONSE_GetRollDetailsFromRollId,
  TMaterialRequestType,
  TREQUEST_GetAddedRollsForTheSelectedItemInCompletedMaterialRequest,
  TRESPONSE_GetAddedRollsForTheSelectedItemInCompletedMaterialRequest,
} from '@monorepo/types';

@Injectable({
  providedIn: 'root',
})
export class Organizi8DataProvider {
  httpOptions = {
    headers: new HttpHeaders({
      'Content-type': 'application/json',
    }),
  };

  constructor(private http: HttpClient, private organizi8EnvProvider: Organizi8EnvProvider) {}

  // ************** CREATE GRN PAGE **************
  fetchFabricCreateGRNLotListing(payload: TREQUEST_FabricGRNLotListing) {
    const URL = this.organizi8EnvProvider.getEnvVar('GET_FABRIC_CREATE_GRN_LOT_LISTING');
    return this.http.post<TRESPONSE_FabricGRNLotListing>(URL, payload, this.httpOptions);
  }

  fetchTrimsCreateGRNLotListing(payload: TREQUEST_TrimsGRNLotListing) {
    const URL = this.organizi8EnvProvider.getEnvVar('GET_TRIMS_CREATE_GRN_LOT_LISTING');
    return this.http.post<TRESPONSE_TrimsGRNLotListing>(URL, payload, this.httpOptions);
  }

  fetchFabricCreateGRNLotDetails(payload: TREQUEST_FabricGRNLotDetails) {
    const URL = this.organizi8EnvProvider.getEnvVar('GET_FABRIC_CREATE_GRN_LOT_DETAILS');
    return this.http.post<TRESPONSE_FabricGRNLotDetails>(URL, payload, this.httpOptions);
  }

  fetchTrimsCreateGRNLotDetails(payload: TREQUEST_TrimsGRNLotDetails) {
    const URL = this.organizi8EnvProvider.getEnvVar('GET_TRIMS_CREATE_GRN_LOT_DETAILS');
    return this.http.post<TRESPONSE_TrimsGRNLotDetails>(URL, payload, this.httpOptions);
  }

  createFabricGRNTag(payload: TREQUEST_GenerateGRNTag) {
    const URL = this.organizi8EnvProvider.getEnvVar('GENERATE_FABRIC_GRN_TAG');
    return this.http.post<TRESPONSE_GenerateGRNTag>(URL, payload, this.httpOptions);
  }

  // ************** STORAGE PAGE **************
  getFabricStorageGRNDetails(payload: TREQUEST_FabricStorageGRNDetails) {
    const URL = this.organizi8EnvProvider.getEnvVar('GET_FABRIC_STORAGE_GRN_DETAILS');
    return this.http.post<TRESPONSE_FabricStorageGRNDetails>(URL, payload, this.httpOptions);
  }

  getTrimsStorageGRNDetails(payload: TREQUEST_TrimsStorageGRNDetails) {
    const URL = this.organizi8EnvProvider.getEnvVar('GET_TRIMS_STORAGE_GRN_DETAILS');
    return this.http.post<TRESPONSE_TrimsStorageGRNDetails>(URL, payload, this.httpOptions);
  }

  getFabricStorageRollsDetails(payload: TREQUEST_FabricStorageRollsDetails) {
    const URL = this.organizi8EnvProvider.getEnvVar('GET_FABRIC_STORAGE_ROLLS_DETAILS');
    return this.http.post<TRESPONSE_FabricStorageRollsDetails>(URL, payload, this.httpOptions);
  }

  getTrimsStorageItemsDetails(payload: TREQUEST_TrimsStorageItemDetails) {
    const URL = this.organizi8EnvProvider.getEnvVar('GET_TRIMS_STORAGE_ITEMS_DETAILS');
    return this.http.post<TRESPONSE_TrimsStorageItemDetails>(URL, payload, this.httpOptions);
  }

  getLocationDetails(payload: TREQUEST_GetLocationDetails, locationSearchId: string) {
    const URL = this.organizi8EnvProvider.getEnvVar('GET_LOCATION_DETAILS') + `/${locationSearchId}`;
    return this.http.post<TRESPONSE_GetLocationDetails>(URL, payload, this.httpOptions);
  }

  addFabricRollsToStorage(payload: TREQUEST_AddFabricRollsToStorage) {
    const URL = this.organizi8EnvProvider.getEnvVar('ADD_FABRIC_ROLLS_TO_STORAGE');
    return this.http.post<TRESPONSE_AddFabricRollsToStorage>(URL, payload, this.httpOptions);
  }

  addTrimItemsToStorage(payload: TREQUEST_AddTrimItemsToStorage) {
    const URL = this.organizi8EnvProvider.getEnvVar('ADD_TRIM_ITEMS_TO_STORAGE');
    return this.http.post<TRESPONSE_AddTrimItemsToStorage>(URL, payload, this.httpOptions);
  }

  // ************** MATERIAL REQUESTS PAGE **************
  fetchMaterialRequestCounts(payload: TREQUEST_MaterialRequestCounts) {
    const URL = this.organizi8EnvProvider.getEnvVar('GET_MATERIAL_REQUEST_COUNTS');
    return this.http.post<TRESPONSE_MaterialRequestCounts>(URL, payload, this.httpOptions);
  }

  getWarehouseMaterialRequests(payload: TREQUEST_GetMaterialRequestsListing) {
    const URL = this.organizi8EnvProvider.getEnvVar('GET_WAREHOUSE_MATERIAL_REQUESTS');
    return this.http.post<TRESPONSE_GetMaterialRequestsListing>(URL, payload, this.httpOptions);
  }

  getFabricItemPendingMaterialRequestDetails(payload: TREQUEST_GetMaterialRequestDetails) {
    const URL = this.organizi8EnvProvider.getEnvVar('GET_FABRIC_ITEM_PENDING_MATERIAL_REQUEST_DETAILS');
    return this.http.post<TRESPONSE_GetMaterialRequestDetails>(URL, payload, this.httpOptions);
  }

  getTrimItemPendingMaterialRequestDetails(payload: TREQUEST_GetMaterialRequestDetails) {
    const URL = this.organizi8EnvProvider.getEnvVar('GET_TRIM_ITEM_PENDING_MATERIAL_REQUEST_DETAILS');
    return this.http.post<TRESPONSE_GetMaterialRequestDetails>(URL, payload, this.httpOptions);
  }

  getFabricItemCompletedMaterialRequestDetails(payload: TREQUEST_GetMaterialRequestDetails) {
    const URL = this.organizi8EnvProvider.getEnvVar('GET_FABRIC_ITEM_COMPLETED_MATERIAL_REQUEST_DETAILS');
    return this.http.post<TRESPONSE_GetMaterialRequestDetails>(URL, payload, this.httpOptions);
  }

  getTrimItemCompletedMaterialRequestDetails(payload: TREQUEST_GetMaterialRequestDetails) {
    const URL = this.organizi8EnvProvider.getEnvVar('GET_TRIM_ITEM_COMPLETED_MATERIAL_REQUEST_DETAILS');
    return this.http.post<TRESPONSE_GetMaterialRequestDetails>(URL, payload, this.httpOptions);
  }

  getRollDetailsFromRollId(payload: TREQUEST_GetRollDetailsFromRollId) {
    const URL = this.organizi8EnvProvider.getEnvVar('GET_ROLL_DETAILS_FROM_ROLL_ID');
    return this.http.post<TRESPONSE_GetRollDetailsFromRollId>(URL, payload, this.httpOptions);
  }

  getAddedRollDetailsForTheSelectedItemInCompletedMaterialRequest(
    payload: TREQUEST_GetAddedRollsForTheSelectedItemInCompletedMaterialRequest,
  ) {
    const URL = this.organizi8EnvProvider.getEnvVar(
      'GET_ADDED_ROLLS_FOR_THE_SELECTED_ITEM_IN_COMPLETED_MATERIAL_REQUEST',
    );
    return this.http.post<TRESPONSE_GetAddedRollsForTheSelectedItemInCompletedMaterialRequest>(
      URL,
      payload,
      this.httpOptions,
    );
  }

  getTrimItemDetailsWithSizes(payload: TREQUEST_FetchTrimItemDetailsWithSizes, requestStatus: TMaterialRequestType) {
    let URL = '';
    if (requestStatus === 'PENDING')
      URL = this.organizi8EnvProvider.getEnvVar('GET_TRIM_PENDING_ITEM_DETAILS_WITH_SIZES');
    else URL = this.organizi8EnvProvider.getEnvVar('GET_TRIM_COMPLETED_ITEM_DETAILS_WITH_SIZES');
    console.log({ URL });
    return this.http.post<TRESPONSE_FetchTrimItemDetailsWithSizes>(URL, payload, this.httpOptions);
  }

  issueSelectedMaterial(payload: TREQUEST_IssueSelectedMaterial) {
    const URL = this.organizi8EnvProvider.getEnvVar('ISSUE_SELECTED_MATERIAL');
    return this.http.post<TRESPONSE_IssueSelectedMaterial>(URL, payload, this.httpOptions);
  }

  // ************** TRANSFER PAGE **************
  // ||||| PHASE 2 |||||
  getAvailableLocationsListing(payload: TREQUEST_AvailableLocationsListing) {
    const URL = this.organizi8EnvProvider.getEnvVar('GET_AVAILABLE_LOCATIONS_LISTING');
    return of({} as TRESPONSE_AvailableLocationsListing);
    // return of({getAvailableLocationsListing});
    // return this.http.post<TRESPONSE_AvailableLocationsListing>(URL, payload, this.httpOptions);
  }

  getItemsStoredInLocationDetails(payload: TREQUEST_ItemsStoredInLocationDetails) {
    const URL = this.organizi8EnvProvider.getEnvVar('GET_ITEMS_STORED_IN_LOCATION');
    return of({} as TRESPONSE_ItemsStoredInLocationDetails);
    // return of(getItemsStoredInLocationDetails);
    // return this.http.post<TRESPONSE_ItemsStoredInLocationDetails>(URL, payload, this.httpOptions);
  }

  getNewLocationDetails(payload: TREQUEST_GetNewLocationDetails) {
    const URL = this.organizi8EnvProvider.getEnvVar('GET_NEW_LOCATION_DETAILS');
    return of({} as TRESPONSE_GetNewLocationDetails);
    // return of(getNewLocationDetails);
    // return this.http.post<TRESPONSE_GetNewLocationDetails>(URL, payload, this.httpOptions);
  }

  confirmItemsTransfer(payload: TREQUEST_ConfirmItemsTransfer) {
    const URL = this.organizi8EnvProvider.getEnvVar('CONFIRM_ITEMS_TRANSFER');
    return of({} as TRESPONSE_ConfirmItemsTransfer);
    // return of(confirmItemsTransfer);
    // return this.http.post<TRESPONSE_ConfirmItemsTransfer>(URL, payload, this.httpOptions);
  }
}
